// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumPosts__list":"st_a bhr_rc bhr_qx bhr_xr","ForumPosts__contest":"st_b bhr_hq","ForumPosts__counselling":"st_c"};